(function(){
  'use strict';
  if(window.RareLockCartFlight&&window.RareLockCartFlight.version)return;

  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pending=null;
  var cleanupTimer=null;
  var errorObserver=null;
  var lastTrigger=null;
  var triggerTimer=null;

  function wait(ms){return new Promise(function(resolve){window.setTimeout(resolve,ms)})}
  function isVisible(rect){return rect&&rect.width>20&&rect.height>20&&rect.bottom>0&&rect.top<window.innerHeight&&rect.right>0&&rect.left<window.innerWidth}

  function clearWatchers(){
    if(cleanupTimer){window.clearTimeout(cleanupTimer);cleanupTimer=null}
    if(errorObserver){errorObserver.disconnect();errorObserver=null}
  }

  function eachFeedbackButton(context,callback){
    if(!context)return;
    if(context.button)callback(context.button);
    if(context.feedbackButton&&context.feedbackButton!==context.button)callback(context.feedbackButton);
  }

  function setButtonText(button,text){
    if(!button)return;
    var span=button.querySelector('span:first-child');
    if(span)span.textContent=text;
    else button.textContent=text;
  }

  function removePendingState(context){
    if(!context)return;
    eachFeedbackButton(context,function(button){button.classList.remove('rl-cart-button-pending')});
    context.pack&&context.pack.classList.remove('rl-cart-pack-pending');
  }

  function cancelPending(){
    clearWatchers();
    removePendingState(pending);
    pending=null;
  }

  function productImage(root){
    if(!root)return null;
    var selectors=[
      '.product__media-item.is-active img',
      '.product__media-item:not([hidden]) img',
      '.product__media img'
    ];
    var fallback=null;
    for(var i=0;i<selectors.length;i++){
      var images=root.querySelectorAll(selectors[i]);
      for(var j=0;j<images.length;j++){
        if(!fallback)fallback=images[j];
        if(isVisible(images[j].getBoundingClientRect()))return images[j];
      }
    }
    return fallback;
  }

  function buildContext(form){
    if(!form||!form.matches('[data-type="add-to-cart-form"]'))return null;
    var productForm=form.closest('product-form');
    var root=productForm&&productForm.closest('product-info');
    if(!productForm||!root)return null;
    var button=productForm.querySelector('.product-form__submit[type="submit"]');
    if(!button||button.disabled||button.getAttribute('aria-disabled')==='true')return null;
    var feedbackButton=lastTrigger&&lastTrigger.isConnected?lastTrigger:button;
    var pack=root.querySelector('.rl-product-offer__choice.is-selected[aria-checked="true"]')||root.querySelector('.rl-product-offer__choice.is-selected');
    var context={
      form:form,
      productForm:productForm,
      root:root,
      button:button,
      feedbackButton:feedbackButton,
      originalButtonText:(button.querySelector('span:first-child')?button.querySelector('span:first-child').textContent:button.textContent).trim(),
      originalFeedbackText:feedbackButton.textContent.trim(),
      pack:pack,
      image:productImage(root),
      createdAt:Date.now()
    };
    lastTrigger=null;
    if(triggerTimer){window.clearTimeout(triggerTimer);triggerTimer=null}
    return context;
  }

  function registerPending(context){
    cancelPending();
    pending=context;
    eachFeedbackButton(context,function(button){button.classList.add('rl-cart-button-pending')});
    if(context.pack)context.pack.classList.add('rl-cart-pack-pending');

    var errorBox=context.productForm.querySelector('.product-form__error-message-wrapper');
    if(errorBox&&window.MutationObserver){
      errorObserver=new MutationObserver(function(){
        if(!errorBox.hasAttribute('hidden'))cancelPending();
      });
      errorObserver.observe(errorBox,{attributes:true,attributeFilter:['hidden']});
    }
    cleanupTimer=window.setTimeout(cancelPending,7000);
  }

  function consumePending(){
    if(!pending)return null;
    var context=pending;
    pending=null;
    clearWatchers();
    return context;
  }

  function cartTarget(){
    var cart=document.querySelector('#cart-icon-bubble');
    if(cart){
      var rect=cart.getBoundingClientRect();
      if(isVisible(rect))return{x:rect.left+rect.width/2,y:rect.top+rect.height/2};
    }
    return{x:Math.max(24,window.innerWidth-30),y:28};
  }

  function flightAnchor(context){
    var imageRect=context.image&&context.image.isConnected?context.image.getBoundingClientRect():null;
    if(isVisible(imageRect))return imageRect;
    var packRect=context.pack&&context.pack.isConnected?context.pack.getBoundingClientRect():null;
    if(isVisible(packRect))return packRect;
    var feedbackRect=context.feedbackButton&&context.feedbackButton.isConnected?context.feedbackButton.getBoundingClientRect():null;
    if(isVisible(feedbackRect))return feedbackRect;
    return context.button&&context.button.isConnected?context.button.getBoundingClientRect():null;
  }

  function fly(context){
    if(reduced||!context.image||!context.image.isConnected)return wait(90);
    var anchor=flightAnchor(context);
    if(!anchor||anchor.width<20||anchor.height<20)return wait(90);

    var mobile=window.innerWidth<750;
    var width=mobile?58:72;
    var height=mobile?72:88;
    var left=Math.max(6,Math.min(window.innerWidth-width-6,anchor.left+anchor.width/2-width/2));
    var top=Math.max(6,Math.min(window.innerHeight-height-6,anchor.top+anchor.height/2-height/2));
    var target=cartTarget();
    var dx=target.x-(left+width/2);
    var dy=target.y-(top+height/2);
    var source=context.image.currentSrc||context.image.src;

    var flight=document.createElement('div');
    flight.className='rl-cart-flight';
    flight.setAttribute('aria-hidden','true');
    flight.style.left=left+'px';
    flight.style.top=top+'px';
    var image=document.createElement('img');
    image.alt='';
    image.src=source;
    var halo=document.createElement('span');
    halo.className='rl-cart-flight__halo';
    flight.appendChild(image);
    flight.appendChild(halo);
    document.body.appendChild(flight);

    if(!flight.animate){
      requestAnimationFrame(function(){
        flight.style.transition='transform .76s cubic-bezier(.22,.76,.18,1),opacity .76s ease';
        flight.style.transform='translate('+dx+'px,'+dy+'px) scale(.18) rotate(6deg)';
        flight.style.opacity='.12';
      });
      return wait(780).then(function(){flight.remove()});
    }

    var animation=flight.animate([
      {transform:'translate(0,0) scale(1) rotate(0deg)',opacity:1,offset:0},
      {transform:'translate('+(dx*.5)+'px,'+(dy*.42-24)+'px) scale(.76) rotate(-4deg)',opacity:1,offset:.5},
      {transform:'translate('+(dx*.82)+'px,'+(dy*.78-10)+'px) scale(.43) rotate(3deg)',opacity:.88,offset:.82},
      {transform:'translate('+dx+'px,'+dy+'px) scale(.16) rotate(7deg)',opacity:.08,offset:1}
    ],{duration:760,easing:'cubic-bezier(.22,.76,.18,1)',fill:'forwards'});

    return animation.finished.catch(function(){}).then(function(){flight.remove()});
  }

  function announce(message){
    var region=document.getElementById('RareLockCartStatus');
    if(!region){
      region=document.createElement('div');
      region.id='RareLockCartStatus';
      region.className='visually-hidden';
      region.setAttribute('role','status');
      region.setAttribute('aria-live','polite');
      document.body.appendChild(region);
    }
    region.textContent='';
    requestAnimationFrame(function(){region.textContent=message});
  }

  function play(context){
    removePendingState(context);
    if(context.pack){
      context.pack.classList.remove('rl-cart-pack-added');
      void context.pack.offsetWidth;
      context.pack.classList.add('rl-cart-pack-added');
    }
    eachFeedbackButton(context,function(button){
      button.classList.remove('rl-cart-button-added');
      void button.offsetWidth;
      button.classList.add('rl-cart-button-added');
      setButtonText(button,'Added ✓');
    });
    announce('Added to cart');

    window.setTimeout(function(){
      if(context.pack)context.pack.classList.remove('rl-cart-pack-added');
    },900);
    window.setTimeout(function(){
      if(context.button){
        context.button.classList.remove('rl-cart-button-added');
        setButtonText(context.button,context.originalButtonText||(window.variantStrings&&window.variantStrings.addToCart)||'Add to cart');
      }
      if(context.feedbackButton&&context.feedbackButton!==context.button){
        context.feedbackButton.classList.remove('rl-cart-button-added');
        setButtonText(context.feedbackButton,context.originalFeedbackText||'Add to cart');
      }
    },1550);

    return fly(context);
  }

  function pulseCart(){
    var cart=document.querySelector('#cart-icon-bubble');
    if(!cart)return;
    cart.classList.remove('rl-cart-target-pop');
    void cart.offsetWidth;
    cart.classList.add('rl-cart-target-pop');
    var bubble=cart.querySelector('.cart-count-bubble');
    if(bubble){
      bubble.classList.remove('rl-cart-count-pop');
      void bubble.offsetWidth;
      bubble.classList.add('rl-cart-count-pop');
    }
    window.setTimeout(function(){
      cart.classList.remove('rl-cart-target-pop');
      if(bubble)bubble.classList.remove('rl-cart-count-pop');
    },760);
  }

  function patchRenderer(tagName){
    if(!window.customElements||!customElements.whenDefined)return;
    customElements.whenDefined(tagName).then(function(){
      var Constructor=customElements.get(tagName);
      if(!Constructor||!Constructor.prototype)return;
      var prototype=Constructor.prototype;
      var original=prototype.renderContents;
      if(typeof original!=='function'||original.__rarelockPatched)return;

      function patchedRenderContents(state){
        var context=consumePending();
        if(!context)return original.call(this,state);
        var instance=this;
        return play(context).catch(function(){}).then(function(){
          var result=original.call(instance,state);
          window.setTimeout(pulseCart,45);
          return result;
        });
      }
      patchedRenderContents.__rarelockPatched=true;
      patchedRenderContents.__rarelockOriginal=original;
      prototype.renderContents=patchedRenderContents;
    });
  }

  document.addEventListener('submit',function(event){
    var context=buildContext(event.target);
    if(context)registerPending(context);
  },true);

  document.addEventListener('click',function(event){
    var stickyButton=event.target.closest&&event.target.closest('[data-rl-sticky-button]');
    if(stickyButton){
      lastTrigger=stickyButton;
      if(triggerTimer)window.clearTimeout(triggerTimer);
      triggerTimer=window.setTimeout(function(){lastTrigger=null;triggerTimer=null},1200);
    }
    var choice=event.target.closest&&event.target.closest('.rl-product-offer__choice:not([disabled])');
    if(!choice)return;
    choice.classList.remove('rl-pack-choice-pop');
    void choice.offsetWidth;
    choice.classList.add('rl-pack-choice-pop');
    window.setTimeout(function(){choice.classList.remove('rl-pack-choice-pop')},460);
  },true);

  window.RareLockCartFlight={
    version:'1.1.0',
    consumePending:consumePending,
    cancelPending:cancelPending,
    play:play,
    pulseCart:pulseCart
  };

  patchRenderer('cart-drawer');
  patchRenderer('cart-notification');
})();
